<template>
  <div>
    <v-sheet
      v-show="!hasSignImg"
      color="grey lighten-3 grey--text"
      max-width="600"
      class="pa-3 mb-2"
    >
      {{ $t('Setting.Sign.NoImg') }}
    </v-sheet>
    <img
      v-show="hasSignImg"
      style="max-height:300px; max-width:600px;"
      :src="src"
    >
    <br>
    <s-file-uploader-with-entity
      ref="fileUploader"
      :post-url="url"
      extensions="jpg,jpeg"
      accept=".jpg,.jpeg"
      :show-no-file-box="false"
      :label="hasSignImg?$t('Setting.Sign.ChangeImg'):$t('Setting.Sign.UploadImg')"
      @uploadSuccess="onUploadSuccess"
      @uploadError="onUploadError"
    />
    <ul class="text-caption grey--text">
      <li>{{ $t('Outbox.Upload.AllowFileType') }}: jpg, jpeg</li>
    </ul>
    <br>
    <v-btn
      v-if="hasSignImg"
      outlined
      color="red"
      @click="deleteSignatureImage"
    >
      {{ $t('Setting.Sign.DeleteImg') }}
    </v-btn>
  </div>
</template>

<script>
import SFileUploaderWithEntity from '@/components/SFileUploaderWithEntity'
import { uploadMethod } from '@/mixins/uploadMethod'
import outboxApi from '@/api/outbox/outbox'
import { arrayBufferToBase64 } from '@/utils/binaryUtil'

export default {
  components: {
    SFileUploaderWithEntity
  },
  mixins: [uploadMethod],
  data: function () {
    return {
      src: null,
      hasSignImg: true
    }
  },
  computed: {
    url: function () {
      return this.$config.apiDomain.ALI + '/ext/ga/core-util-outbox/outbox/api/updateSignatureImage'
    }
  },
  created () {
    this.getSignatureImage()
  },
  methods: {
    deleteSignatureImage () {
      outboxApi.deleteSignatureImage(resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.hasSignImg = false
        }
      })
    },
    getSignatureImage () {
      outboxApi.getSignatureImage(resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.src = 'data:image/jpeg;base64, ' + arrayBufferToBase64(resp.data)
          this.hasSignImg = true
        } else if (resp.status === 204) {
          this.hasSignImg = false
        }
      })
    },
    onUploadSuccess () {
      this.$refs.fileUploader.clearFile()
      this.getSignatureImage()
    }
  }
}
</script>
